import { ADMIN_GROUP } from '../constants/services'
import { AuthUser } from './auth-user.dto'

export type AccessConfigKey =
  | 'offlineAuthAdminUsers'
  | 'administrationAllowedUsers'
  | 'dashboardSalesUsers'
  | 'synchronizerReplayOnlyUsers'
  | 'pricingAllowedUsers'
  | 'warehouseSetsAllowedUsers'
  | 'servicesAllowedUsers'
  | 'serviceTechnicianEditUsers'
  | 'attachmentsAdminUsers'
  | 'harviaProductsDeleteUsers'
  | 'wholesaleAccountsAdminUsers'
  | 'inventoryActionUsers'
  | 'returnedGoodsServiceUsers'
  | 'serviceDetailUpdateUsers'
  | 'multiServiceOfferUsers'
  | 'saunaClubDownloadUsers'
  | 'servicesWarehouseUsers'
  | 'servicesWarehouseGroups'

export type AccessGroupNamesConfigKey = 'servicesWarehouseGroupNames'

export type AccessConfig = Record<AccessConfigKey, number[]> & Record<AccessGroupNamesConfigKey, string[]>

/**
 * Pravidlo přístupu k funkci portálu: uživatel projde, pokud je členem některé ze skupin Vision
 * nebo je jeho ID v seznamu runtime konfigurace `usersKey` (env `CLIENT_ACCESS_*`).
 */
export interface AccessRule {
  groups: number[]
  usersKey?: AccessConfigKey
}

/** Registr funkcí portálu chráněných přes `canAccess` (server `@RequireAccess`, klient `AccessService`). */
export const ACCESS_FEATURES = {
  workGroups: { groups: [ADMIN_GROUP], usersKey: 'administrationAllowedUsers' },
} satisfies Record<string, AccessRule>

export type AccessFeature = keyof typeof ACCESS_FEATURES

export type AccessUser = Pick<AuthUser, 'user_id' | 'groups' | 'authProvider'>

/** Offline přihlášení nemá ověřené skupiny Vision, proto chráněné funkce nikdy nepovolí. */
export const canAccess = (user: AccessUser | null | undefined, feature: AccessFeature, config: AccessConfig): boolean => {
  if (!user || user.authProvider === 'offline') return false

  const rule: AccessRule = ACCESS_FEATURES[feature]
  const allowedUsers = rule.usersKey ? config[rule.usersKey] : []

  return (
    (typeof user.user_id === 'number' && allowedUsers.includes(user.user_id)) ||
    !!user.groups?.some(group => rule.groups.includes(group.id))
  )
}
